<button 
  *ngIf="isVisible"
  class="floating-appointment-btn"
  [class.exiting]="isExiting"
  (click)="onAppointmentClick()"
  aria-label="Book an appointment">
  
  <div class="icon-container">
    <i class="fas fa-calendar-check"></i>
  </div>
  
  <div class="text-container">
    <span>{{ t('bookAnAppointment') }}</span>
  </div>
</button>
